import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

// Modern button styling - made thinner and smaller for mobile
const ReferralButton = styled.button`
  background: linear-gradient(135deg, #3343a3 0%, #7a8fd4 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(51, 67, 163, 0.4);
  z-index: 2;
  white-space: nowrap;

  @media (min-width: 1200px) {
    padding: 12px 24px;
    font-size: 12px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(51, 67, 163, 0.6);
    animation: ${bounce} 0.6s ease-in-out;
  }

  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 768px) {
    padding: 6px 16px;
    font-size: 9px;
    letter-spacing: 0.3px;
    border-radius: 20px;
  }

  @media (max-width: 480px) {
    padding: 5px 14px;
    font-size: 8px;
  }
`;

export default ReferralButton;
